export default __webpack_public_path__ + "static/media/JFResume2026.92d33dbc.jpg";